import {useContext, useEffect} from 'react';
import {SharedBackdropContext} from './shared-backdrop-context';

export const useSharedBackdrop = (isVisible: boolean): void => {
  const {register} = useContext(SharedBackdropContext);

  useEffect(() => {
    if (!isVisible) return;
    return register();
  }, [isVisible, register]);
};
